import { endpoints } from "@sunrise/backend-types";
import { AxiosError } from "axios";

export function isNotKnownUserError(error: AxiosError): boolean {
  return !!(
    error.config?.url?.endsWith(endpoints.me("")) &&
    error.response?.status &&
    [404].includes(error.response.status)
  );
}
